<template>
  <v-btn-form :title="title" @close="cancel()">
    <v-card-text>
      {{errorMessage}}
      <v-form v-model="valid" ref="form">
        <v-text-field 
          v-model="code"
          type="text"
          label="Введите код подтверждения"
          clearable
        ></v-text-field>
      </v-form>
    </v-card-text>
    <template #actions>
      <v-btn :disabled="!valid"
        @click="send" >Ок</v-btn>
      <v-btn
        @click="request" >Получить код</v-btn>
    </template>  
  </v-btn-form>
</template>

<script>
  import server from '../../api/server'
  import formats from '../../api/formats'
  import vBtnForm from '../common/BtnForm'

  export default {
    name: 'v-confirm-dlg',
    components: {vBtnForm},
    data: () => ({
      valid: false,
      code: '',
      title: 'Подтверждение операции',
      errorMessage: '',
      expiryTime: null
    }),
    props: {
      actionCode: {
        type: String,
        default: null
      },
      resourceId: {
        type: Number,
        default: null
      },
      fullscreen: {
        type: Boolean,
        default: false
      }
    },
    created () {
      this.fetchInfo()
    },
    methods: {
      cancel () {
        this.$emit('close')
      },
      send () {
        const cb = (data) => {
          this.$emit('refresh')
          this.cancel()
        }
        const cbError = (e) => {
          var error = e
          if (error.response && error.response.data && error.response.data.code) {
            switch (error.response.data.code) {
              case 'CONFIRMATION_CODE_WRONG':
                this.$store.commit('setWarningStatus', 'Неверный код подтверждения или истек срок действия кода.')
                return
            }
          }
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при посылке кода подтверждения '})
        }
        server.apiPost(
          '/api/me/confirmations',
          {code: this.code},
          cb,
          cbError)
      },
      request () {
        const cb = (data) => {
          this.fetchInfo()
        }
        const cbError = (e) => {
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при запросе кода подтверждения '})
        }
        server.apiPost(
          '/api/me/confirmation-requests',
          {
            actionCode: this.actionCode,
            resourceId: this.resourceId
          },
          cb,
          cbError)
      },
      fetchInfo () {
        const cb = (data) => {
          if (data.length > 0) {
            this.expiryTime = data[0].expiryTime
            this.errorMessage = `Код подтверждения был выслан по смс на телефон ${data[0].address}. Срок действия кода до ${formats.formatTime(data[0].expiryTime)} по московскому времени.`
          } else {
            this.errorMessage = `Для подтверждения операции получите по смс код подтверждения, нажав кнопку "Получить Код", и вставьте его в поле "Введите код подтверждения"`
          }
        }
        const cbError = (e) => {
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о кодах подтверждения '})
        }
        server.apiGet(
          '/api/me/confirmation-requests',
          cb,
          cbError)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ConfirmDialog.vue?6e26c440